import { storage as r } from "@gitcoffee/storage";
function s(t, a = null) {
  try {
    const e = r.getItem(t);
    return e instanceof Promise ? a : e !== null ? e : a;
  } catch (e) {
    return console.error(`Failed to get item ${t}:`, e), a;
  }
}
function c(t, a) {
  try {
    r.setItem(t, a) instanceof Promise;
  } catch (e) {
    console.error(`Failed to set item ${t}:`, e);
  }
}
const n = {
  // 通用设置
  enableLanguageSetting: !0,
  language: "zh-CN",
  enableThemeSetting: !0,
  theme: "light",
  // 界面设置
  openMode: "drawer",
  // 交互设置
  notificationEnabled: !0,
  soundEnabled: !1,
  // 数据设置
  dataStorage: "local",
  autoBackupEnabled: !0,
  // 模板设置
  templateEnabled: !0,
  defaultTemplate: "default",
  // 系统设置
  isBrowserTab: !1,
  // 折叠面板设置 - 默认展开所有面板
  activeCollapseKeys: [
    "market",
    "plugins",
    "account",
    "backup",
    "feedback",
    "about",
    "system",
    "language",
    "theme",
    "ui",
    "interaction",
    "data",
    "dataManagement",
    "template",
    "search",
    "searchBox",
    "searchPlatforms",
    "tags"
  ]
};
function i(t = {}) {
  return { ...n, ...t };
}
export {
  i as createBaseSettingData,
  n as defaultBaseSettingData,
  s as syncGet,
  c as syncSet
};
